import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export function useEsignSetup(enabled = true) {
  const [config, setConfig] = useState(null);
  const [signatories, setSignatories] = useState([]);

  const load = useCallback(async () => {
    const [c, s] = await Promise.all([api.get("/esign/config"), api.get("/esign/signatories")]);
    setConfig(c.data);
    setSignatories((s.data || []).filter((x) => x.active));
  }, []);

  useEffect(() => {
    if (enabled) { load().catch(() => {}); }
  }, [enabled, load]);

  return { config, signatories, reload: load };
}

export async function createEsignRequest({ blob, fileName, signatoryId, docType, docRef, title }) {
  const fd = new FormData();
  fd.append("file", blob, fileName || "document.pdf");
  fd.append("signatory_id", signatoryId);
  fd.append("doc_type", docType || "document");
  fd.append("doc_ref", docRef || "");
  fd.append("title", title || "");
  const r = await api.post("/esign/requests", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data;
}
